module.exports = __webpack_public_path__ + "static/media/29ADMSPC10.5f362715.jpg";